export const DEFAULT_PALETTE_COLORS = [
  { hex: "#FFFFFF" },
  { hex: "#D6D6D6" },
  { hex: "#0A0E13" },
  { hex: "#FECE1E" },
  { hex: "#F32E48" },
  { hex: "#02C39A" },
  { hex: "#2A79C4" },
  { hex: "#B3E5FC" },
  { hex: "#C3C6F9" },
  { hex: "#8064CE" },
  { hex: "#FE861E" },
  { hex: "#FF7DC9" },
  { hex: "#028090" },
  { hex: "#095482" },
];

export const RECENTLY_USED_STORAGE_KEY = "recently-used-colors";

export const TARGET_SIZES = {
  small: "small",
  medium: "medium",
  large: "large",
} as const;

export const PICKER_HEIGHT: Record<string, string> = {
  small: "100px",
  medium: "120px",
  large: "140px",
};
